import { Lexer } from "./Lexer";
import { LexerMatcher } from "./LexerMatcher";
import { LexerMatcherLibrary } from "./LexerMatcherLibrary";
import { LexerType } from "./LexerType";

export class WordLexer extends Lexer
{
  constructor()
  {
    super();

    this.addAllMatchers( 
      LexerMatcherLibrary.WHITESPACE_MATCHER,
      LexerMatcherLibrary.ANY_SYMBOL_MATCHER
    );

  }
}